const translations = {
    addButtonLabel: 'Add',
    flightGroupSaveError: 'Failed to save flight group, group name is required',
    flightGroupSaveMessage: 'Flight group saved successfully',
    noProductUsageReports: 'No Product Usage Reports Exist',
    productUsageReportsSectionTitle: 'Associated Product Usage Reports',
    saveButtonLabel: 'Save',
    title: 'Create Group'
};

export default translations;
